import React, {FC} from "react"
import Flex from "@irati/ui/src/Flex"
import zipLogo from "@irati-web/payments/src/images/zip_logo2.svg"
import zipHeart from "@irati-web/payments/src/images/zip-modal-heart.svg"
import zipCart from "@irati-web/payments/src/images/zip-modal-cart.svg"
import zipThumbUp from "@irati-web/payments/src/images/zip-modal-thumb-up.svg"
import FormattedMessage from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"
import {Row, Col} from "react-bootstrap"
import tracking from "@irati-tracking/perks/perks"

import {ZipLogoModal, ZipH3, ZipModalImage, ZipBody, ZipH2, ZipModalButtonLink} from "./styled"

const ZipModalContent: FC = () => {
  return (
    <>
      <ZipLogoModal src={zipLogo} />
      <Flex justifyContent="center">
        <ZipH2>
          <FormattedMessage id="platform.payments.zip.modalTitle" />
        </ZipH2>
      </Flex>
      <Body textAlign="center" small>
        <FormattedMessage id="platform.payments.zip.modalSubtitle" />.
      </Body>

      <Row>
        <Col md={4}>
          <Flex justifyContent="space-around">
            <ZipModalImage src={zipHeart} />
          </Flex>
          <ZipH3>
            <FormattedMessage id="platform.payments.zip.wantit.header" />
          </ZipH3>
          <ZipBody>
            <FormattedMessage id="platform.payments.zip.wantit.body" />
          </ZipBody>
        </Col>

        <Col md={4}>
          <Flex justifyContent="space-around">
            <ZipModalImage src={zipCart} />
          </Flex>
          <ZipH3>
            <FormattedMessage id="platform.payments.zip.getit.header" />
          </ZipH3>
          <ZipBody>
            <FormattedMessage id="platform.payments.zip.getit.body" />
          </ZipBody>
        </Col>

        <Col md={4}>
          <Flex justifyContent="space-around">
            <ZipModalImage src={zipThumbUp} />
          </Flex>
          <ZipH3>
            <FormattedMessage id="platform.payments.zip.ownit.header" />
          </ZipH3>
          <ZipBody>
            <FormattedMessage id="platform.payments.zip.ownit.body" />
          </ZipBody>
        </Col>
      </Row>
      <Flex justifyContent="center">
        <ZipModalButtonLink primary target="_blank" href="https://zip.co/uk/how-it-works/" onClick={tracking.moreAboutZip}>
          <FormattedMessage id="platform.payments.zip.moreAboutZip" />
        </ZipModalButtonLink>
      </Flex>
    </>
  )
}

export default ZipModalContent
